// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ConfettiTriangle_02 = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M0 16 7 0l18 16H0Z" fill="#FF5959" />
	</svg>
);
export default ConfettiTriangle_02;
